const Video = ({ videoData }: { videoData: any[] }) => {
    return (
        <section className="introductionVideo">
                <div className='container'>
                    {videoData && videoData.length > 0 && videoData.map((item: any, index: number) => {
                        return (
                            <div key={index}>
                                <video controls autoPlay muted loop playsInline>
                                    <source src={`${item.url}`} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        );
                    })}
                </div>
            </section>
    );
};
export default Video;
